<div>
       <div class="flex flex_row flex_sb fs-16"><div class="fs-20 fw-700">{{ 'REOCCUR_MODAL_HEADER' | fallbackTranslate }}</div>  <img (click)="dismissModal()" [src]="images?.GRAY_CLOSE_IMG"  alt="image" /> </div>
       <ul>
        <li class="m-t-25">{{ 'REOCCUR_MODAL_P1' | fallbackTranslate }} <div *ngIf="showRazorText" class="display_inline">{{ 'REOCCUR_MODAL_P4' | fallbackTranslate }} <div class="fs-14 fw-700 display_inline">"RAZER-CRETAPS"</div></div></li>
        <li class="m-t-30">{{ 'REOCCUR_MODAL_P2' | fallbackTranslate }}</li>
        <li class="m-t-30">{{ 'REOCCUR_MODAL_P3' | fallbackTranslate }}</li>
        </ul>
</div>    